import { render, staticRenderFns } from "./HomeModern.vue?vue&type=template&id=d9436b74&scoped=true"
import script from "./HomeModern.vue?vue&type=script&lang=js"
export * from "./HomeModern.vue?vue&type=script&lang=js"
import style0 from "./HomeModern.vue?vue&type=style&index=0&id=d9436b74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9436b74",
  null
  
)

export default component.exports